import { createTheme } from "@mui/material/styles";

export const themeLight = createTheme({
  cssVariables: true,
  palette: {
    mode: "light",
    primary: {
      main: "#294e6b",
      light: "#678193",
    },
    secondary: {
      main: "#404040",
      title: "#616365",
    },
    fontWhite: {
      main: "#fff",
    },
    status: {
      main: "#a4ffaa",
    },
    colors: {
      green: "#4CAF50",
      yellow: "#F9B934",
      pink: "#E91E63",
      blue: "#3F51B5",
    },
    white: "#ffffff",
    texts: {
      primary: "#fff",
      secondary: "#fff",
      text1: "#294e6b",
    },
    background: {
      main: "#fff",
    },
  },
  typography: {
    htmlFontSize: 16,
    fontSize: 14,
    fontFamily: [
      '"Futura PT"',
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
});

export const themeDark = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#666666",
    },
    secondary: {
      main: "#2196F3",
      title: "#fff",
    },
    colors: {
      green: "#4CAF50",
      yellow: "#F9B934",
      pink: "#E91E63",
      blue: "#3F51B5",
    },
    white: "#ffffff",
    texts: {
      primary: "#fff",
      secondary: "#eae6e6",
    },
    background: {
      main: "#020000",
    },
  },
  typography: {
    htmlFontSize: 16,
    fontSize: 14,
    fontFamily: [
      "'Lato'",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
});

export const themeContrast = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#666666",
    },
    secondary: {
      main: "#2196F3",
      title: "#fff",
    },
    colors: {
      green: "#4CAF50",
      yellow: "#F9B934",
      pink: "#E91E63",
      blue: "#3F51B5",
    },
    white: "#F9B934",
    texts: {
      primary: "#F9B934",
      secondary: "#eeb844",
    },
    background: {
      main: "#F9B934",
    },
  },
  typography: {
    htmlFontSize: 16,
    fontSize: 14,
    fontFamily: [
      "'Lato'",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
});
